import { FILTER_USER_MAP } from './constants'

// Filter configuration for user filtering
export const FILTER_CONFIG = {
  all: {
    filter: users => users,
    query: '',
  },
  admin: {
    filter: users => users.filter(user => user.roles.includes('Admin')),
    query: '?role=Administrator',
  },
  teacher: {
    filter: users => users.filter(user => user.roles.includes('Teacher')),
    query: '?role=Teacher',
  },
  pending: {
    filter: users =>
      users.filter(user => user.isActive === true && user.status === 'Invited'),
    query: '?accountStatus=pending',
  },
  noClasses: {
    filter: users => users.filter(user => user.classesCreated === 0),
    query: '?classCount=0',
  },
  leaderTeam: {
    filter: users => users.filter(user => user.roles.includes('Leader Team')),
    query: '?role=LeaderTeam',
  },
}

// Helper to determine filter option from URL query params
export const getFilterOptionFromQuery = query => {
  if (!query) {
    return { key: 'all', name: FILTER_USER_MAP.all }
  }

  if (query.accountStatus === 'pending') {
    return { key: 'pending', name: FILTER_USER_MAP.pending }
  }

  if (query.classCount === '0' || query.classCount === 0) {
    return { key: 'noClasses', name: FILTER_USER_MAP.noClasses }
  }

  const roleMap = {
    Administrator: { key: 'admin', name: FILTER_USER_MAP.admin },
    LeaderTeam: { key: 'leaderTeam', name: FILTER_USER_MAP.leaderTeam },
    Teacher: { key: 'teacher', name: FILTER_USER_MAP.teacher },
  }

  if (query.role && roleMap[query.role]) {
    return roleMap[query.role]
  }

  return { key: 'all', name: FILTER_USER_MAP.all }
}

// Calculate user counts from active users
export const calculateUserCounts = activeUsers => {
  return activeUsers.reduce(
    (counts, user) => {
      const role = user.roles[0]
      const isActive = !!user.userId

      switch (role) {
        case 'Admin':
          counts.admin++
          isActive ? counts.adminActive++ : counts.adminPending++
          break
        case 'Leader Team':
          counts.leaderTeam++
          isActive ? counts.leaderTeamActive++ : counts.leaderTeamPending++
          break
        case 'Teacher':
          counts.teacher++
          isActive ? counts.teacherActive++ : counts.teacherPending++
          break
        default:
          console.warn(`Unknown role: ${role}`)
      }

      if (!isActive) {
        counts.pending++
      }

      if (user.classesCreated === 0) {
        counts.noClasses++
      }

      return counts
    },
    {
      pending: 0,
      all: activeUsers.length,
      admin: 0,
      adminActive: 0,
      adminPending: 0,
      leaderTeam: 0,
      leaderTeamActive: 0,
      leaderTeamPending: 0,
      teacher: 0,
      teacherActive: 0,
      teacherPending: 0,
      noClasses: 0,
    },
  )
}
